import React, { useEffect } from "react";
import "./OrderHistory.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import { useDispatch, useSelector } from "react-redux";
import { getOrderList } from "redux/MedicalAlertUsers/actions";
import { useHistory } from "react-router-dom";
import { formatDate } from "utility";
import { ROUTES_CONSTANTS } from "routes/route-constants";

const OrderHistory = () => {
  const { orderList, loading, selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    getOrderList({
      dispatch,
      history,
      medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
    });
  }, []);

  const onPressOrderCard = (orderDetail) => {
    history.push(ROUTES_CONSTANTS?.orderDetails, { orderDetail: orderDetail });
  };

  return (
    <MainLayout
      text={titles?.order_history}
      isBackHide={false}
      isNavbar={true}
      white={true}
      isLoading={loading}
    >
      <div className="oh_main_container">
        <div className="oh_content_container">
          <h2 className="oh_orders_section_title">{titles?.orders}</h2>
          {!loading ? orderList && orderList.length > 0 ? (
            <div className="oh_orders_list_container">
              {orderList?.map((item, index) => {
                const order_detail = item?.order_detail;
                return (
                  <div
                    key={`order-${index}`}
                    onClick={() => onPressOrderCard(item)}
                    className="oh_order_card_container"
                  >
                    <div className="oh_order_card">
                      <div className="oh_order_header">
                        <p className="oh_order_number">
                          {titles?.order}: {order_detail?.order_id}
                        </p>
                        <p className="oh_order_date">
                          {formatDate(order_detail?.order_date)}
                        </p>
                      </div>
                      
                      <div className="oh_order_divider"></div>
                      
                      <div className="oh_order_details">
                        <div className="oh_order_detail_row">
                          <p className="oh_order_label">{titles?.subscription}</p>
                          <p className="oh_order_value">
                            {order_detail?.subscription}
                          </p>
                        </div>
                        <div className="oh_order_detail_row">
                          <p className="oh_order_label">{titles?.total}</p>
                          <p className="oh_order_value">
                            {"$" + order_detail?.total_recurring_fees?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
              <p className="alert_empty_message">{titles?.empty_order_list}</p>
          ) : null}
        </div>
      </div>
    </MainLayout>
  );
};

export default OrderHistory;
